module.exports = __webpack_public_path__ + "static/media/aestheteMobile.a5982505.png";